import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import CompanyMjp from "~/components/job-page/mjp/company-mjp";
import JobAdTemplateMjp from "~/components/job-page/mjp/jobad-template-mjp";
import ApplicationProcessMailFirstEon from "~/components/job-page/subclients/shared/application-process-mail-first-eon";

/** Shared manual-job-posting (mjp) layout, used by the edg-sub and edri subclients. */
export const defaultMjp = createSubtemplate<SectionKey>({
  name: "mjp",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      companyInfo: CompanyMjp,
      jobDescription: JobAdTemplateMjp,
      applicationProcess: ApplicationProcessMailFirstEon,
    },
    sections: [
      "stickyContact",
      "headerImage",
      "breadcrumb",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "diversity",
      "about",
      "benefits",
      "similarJobs",
      "printView",
    ],
  },
});
